import {
    HotkeyBinding,
    View,
} from 'radpresentation.htmlclient.defaultviewextensions';
import type CreateDynamicAssociationViewModel from '@/ViewModels/Views/CreateDynamicAssociationViewViewModel';
import layout from './CreateDynamicAssociationView.html?raw';

class CreateDynamicAssociationView extends View {
    private view: JQuery<HTMLElement>;

    constructor(
        private viewModel: CreateDynamicAssociationViewModel,
        private element: any
    ) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        HotkeyBinding.addHotkey(
            this.view[0],
            'esc',
            this.viewModel.cancel.onClick.bind(this)
        );
        HotkeyBinding.addHotkey(
            this.view[0],
            'enter',
            this.viewModel.okay.onClick.bind(this)
        );

        return this.view;
    }
}

export default CreateDynamicAssociationView;
